/**
 * en-GB messages added by the Phase 2 architect skeleton (permissions, module names, shared error keys, merge fields).
 * Builders don't edit this file; ask the Master Bot. Flat keys, `{name}` placeholders, merged by ./index.ts.
 */
export const archEnGB = {
    'module.companion': 'Companion app',
    'permGroup.preregistrations': 'Pre-registrations',
    'perm.preregistrations.view': 'View pre-registrations at their sites',
    'perm.preregistrations.manage': "Create, change and cancel anyone's pre-registrations",
    'permGroup.omp_link': 'Oakford Mobile Portal link',
    'perm.omp_link.view': 'View the Oakford Mobile Portal link and its messages',
    'perm.omp_link.manage': 'Set up the Oakford Mobile Portal link',
    // Error message keys used with existing error codes (ADR 0017, 0019)
    'error.link_invalid': 'This link has expired or is no longer valid.',
    'error.idempotency_conflict': 'This request reused an idempotency key with different details.',
    'error.person_not_matched': 'This person could not be matched to anyone in CloudSign. They have been added to the "needs matching" list.',
    'error.api_scope': 'This API key is not allowed to make this call.',
    // Merge fields (packages/shared/src/emails/merge-fields.ts)
    'merge.tenant.name': 'Organisation name',
    'merge.site.name': 'Site name',
    'merge.site.address': 'Site address',
    'merge.group.name': 'Group name',
    'merge.person.name': "Person's full name",
    'merge.person.first_name': "Person's first name",
    'merge.person.email': "Person's email",
    'merge.host.name': 'Host name',
    'merge.host.email': 'Host email',
    'merge.host.phone': 'Host phone',
    'merge.visit.signed_in_at': 'Sign-in time',
    'merge.visit.signed_out_at': 'Sign-out time',
    'merge.visit.date': 'Visit date',
    'merge.visit.duration': 'Time on site',
    'merge.visit.method': 'How they signed in',
    'merge.visit.device': 'Kiosk name',
    'merge.prereg.expected_date': 'Expected date',
    'merge.prereg.expected_time': 'Expected time',
    'merge.prereg.link': 'Pre-arrival page link',
    'merge.prereg.qr': 'QR code',
    'merge.prereg.notes': 'Notes for the visitor',
    'merge.member.start_date': 'Start date',
    'merge.member.qr': 'Personal QR code',
    'merge.companion.link': 'CloudSign app invite link',
    'merge.feedback.link': 'Feedback link',
    'merge.feedback.rating_links': 'One-tap rating buttons',
    'merge.report.time': 'Report time',
    'merge.report.count': 'Number of people on site',
};
//# sourceMappingURL=arch.js.map